import React from "react";
import { Link } from "react-router-dom";   // ✅ Added import
import "./About.scss";

// import imgTop from "../../assets/about-bottom.jpg";     // tall image (right)
import imgTop from "../../assets/companyimages/img4.jpg"; 
// import imgBottom from "../../assets/about-top.jpg";  
import imgBottom from "../../assets/officesetup.jpg";      
import shape from "../../assets/shape.png";

export default function About() {
  return (
    <section className="avena-about" id="about">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* LEFT: Content (col-5) */}
          <div className="col-12 col-lg-6">
            <h2 className="avena-about__title">
              <span>Avena InfoTech</span> <br />
              Solutions Around The World
            </h2>

            <p className="avena-about__lead">
              We design and deliver secure software and dependable hardware—
              helping teams move faster with clarity and control.
            </p>

            <p className="avena-about__lead">
              From custom applications and cloud infrastructure to networks, CCTV,
              and access control, our projects are built for performance, scale, and
              long-term maintainability. We integrate best-practice security and
              observability so your systems stay reliable and easy to operate.
            </p>

            {/* ✅ Updated link to use React Router */}
            <Link to="/about" className="btn avena-about__cta">
              More About Us
            </Link>
          </div>

          {/* RIGHT: Image stack (col-7) */}
          <div className="col-12 col-lg-6">
            <div className="avena-about__stack">
              <img src={shape} className="shape-about" alt="" />

              {/* Main tall image on the right */}
              <div className="avena-about__photo avena-about__photo--main">
                <img src={imgTop} alt="Technician auditing checklist" loading="lazy" />
              </div>

              {/* Smaller overlapping image on the left */}
              <div className="avena-about__photo avena-about__photo--overlap">
                <img src={imgBottom} alt="Forklift with packages top-down" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
